import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { decryptAES } from "../../../utils/EncryptorUtils";
import { useNavigation } from "../../../hooks/useNavigation";
import { useAuthSlice } from "../../../redux/slice/authSlice";
import ExternalAccessLayout from "../../common/ExternalAccessLayout";
import ExternalAccessSignInDialog from "../../common/ExternalAccessSignInDialog";
import { AGREEMENT_REQUEST_STATUS } from "../../../constants/applicationConstants";

const AgreementRequestAccess: React.FC = () => {
  const { navigate } = useNavigation();
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const { isValid } = useAuthSlice();
  const [practiceId, setPracticeId] = useState<number | null>(null);
  const [productId, setProductId] = useState<number | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encryptedPracticeId = params.get("practiceId") || null;
    const encryptedProductId = params.get("productId") || null;
    const iv = params.get("iv");
    const salt = params.get("salt");

    if (encryptedPracticeId) {
      const pid = Number(decryptAES(encryptedPracticeId, iv, salt));
      if (Number.isFinite(pid)) {
        setPracticeId(pid);
      }
    }

    if (encryptedProductId) {
      const prodId = Number(decryptAES(encryptedProductId, iv, salt));
      if (Number.isFinite(prodId)) {
        setProductId(prodId);
      }
    }
  }, [location.search]);

  useEffect(() => {
    if (isValid && practiceId && productId) {
      navigate("/products/agreement_request_list", {
        state: {
          agreementRequestListSearchCriteria: {
            practiceIds: [practiceId],
            productIds: [productId],
            manufacturerIds: [],
            status: [AGREEMENT_REQUEST_STATUS.REQUESTED],
            currentPage: 0,
            itemsPerPage: 10,
            downloadState: false,
          },
        },
        replace: true,
      });
    } else if (practiceId && productId) {
      setShowPopup(true);
    }
  }, [isValid, practiceId, productId, navigate]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <ExternalAccessLayout
        title="Agreement Request Access"
        description="Please sign in to view the agreement request list."
      />

      {showPopup && practiceId && productId && (
        <ExternalAccessSignInDialog
          onClose={handleClosePopup}
          email=""
          allowEmailEdit={true}
          title="Agreement Request Access"
          description="Please enter your email and password to access the agreement request."
          submitButtonLabel="Access Agreement Request"
          onAuthorized={() => {
            navigate("/products/agreement_request_list", {
              state: {
                agreementRequestListSearchCriteria: {
                  practiceIds: [practiceId],
                  productIds: [productId],
                  manufacturerIds: [],
                  status: [AGREEMENT_REQUEST_STATUS.REQUESTED],
                  currentPage: 0,
                  itemsPerPage: 10,
                  downloadState: false,
                },
              },
              replace: true,
            });
          }}
        />
      )}
    </>
  );
};

export default AgreementRequestAccess;
